import { render } from "./GalacticButton.vue?vue&type=template&id=2d7fea31&scoped=true"
import script from "./GalacticButton.vue?vue&type=script&lang=js"
export * from "./GalacticButton.vue?vue&type=script&lang=js"

import "./GalacticButton.vue?vue&type=style&index=0&id=2d7fea31&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d7fea31"]])

export default __exports__